import React, { useCallback } from 'react';

type useImageRotationParams = {
    cropperRef: React.RefObject<any>;
    isDirtyRef: React.MutableRefObject<boolean>;
    initialCropDataRef: React.MutableRefObject<any>;
    currentRotation: number;
    initialRotation: number;
    setCurrentRotation: (val: number) => void;
    setHideDrawing: (val: boolean) => void;
};

export function useImageRotation({
    cropperRef,
    isDirtyRef,
    initialCropDataRef,
    currentRotation,
    initialRotation,
    setCurrentRotation,
    setHideDrawing,
}: useImageRotationParams) {
    const handleRotateImage = useCallback(() => {
        const cropper = cropperRef.current;
        isDirtyRef.current = true;

        // Save the current crop data, so we can rotate it on re-render (see useLayoutEffect in ImageModalEditor.ts)
        initialCropDataRef.current = cropper.getCropBoxData();

        cropper.clear();
        cropper.rotate(-90);
        cropper.crop();

        const newRotation = currentRotation === -270 ? 0 : currentRotation - 90;

        setHideDrawing(initialRotation !== newRotation);
        setCurrentRotation(newRotation);
    }, [
        cropperRef,
        isDirtyRef,
        initialCropDataRef,
        currentRotation,
        initialRotation,
        setCurrentRotation,
        setHideDrawing,
    ]);

    return { handleRotateImage };
}
